import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import './header.css';
import FlashingTitles from '../FlashingTitles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { headerData } from '../../data/headerData';
import Callbackpopup from '../callbackpopup/Callbackpopup';

const Header = ({ titleList, definationList, img }) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const heroImg =
    typeof img === 'string' && img.trim() !== ''
      ? img.trim()
      : headerData.homeHeroImageUrl;
  const { badge, defaultTitles, defaultDescriptions, cta, stats, image } = headerData;
  const titles = titleList && titleList.length > 0 ? titleList : defaultTitles;
  const descriptions = definationList && definationList.length > 0 ? definationList : defaultDescriptions;

  const openCallbackPopup = () => {
    setPopupOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeCallbackPopup = () => {
    setPopupOpen(false);
    document.body.style.overflow = 'auto';
  };

  const scrollToOffers = () => {
    if (location.pathname !== '/') {
      // If not on home page, navigate first
      navigate('/');
      // Wait for navigation and then scroll
      setTimeout(() => {
        const element = document.getElementById('process-flow-offers');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // If already on home page, just scroll
      const element = document.getElementById('process-flow-offers');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return(
    <div className="clean-hero" id="home">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <CheckCircleIcon className="badge-icon" />
            <span>{badge.text}</span>
          </div>
          
          <h1 className="hero-title">
            <FlashingTitles titles={titles} interval={10000} />
          </h1>
          
          <p className="hero-description">
            <FlashingTitles titles={descriptions} interval={10000} />
          </p>

          <div className="hero-cta">
            <button className="cta-primary" onClick={openCallbackPopup}>
              <PhoneIcon className="cta-icon" />
              <span>{cta.primary.text}</span>
              <ArrowForwardIcon className="cta-arrow" />
            </button>
            <button className="cta-secondary" onClick={scrollToOffers}>
              <LocalOfferIcon className="cta-icon" />
              <span>{cta.secondary.text}</span>
              <ArrowForwardIcon className="cta-arrow" />
            </button>
          </div>

          <div className="hero-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-image">
          <img src={heroImg} alt={image.alt} width="800" height="600" />
        </div>
      </div>
      {/* Callback Popup */}
      {isPopupOpen && <Callbackpopup onClose={closeCallbackPopup} cardItem={cta.primary.text} />}
    </div>
  );
};
export default Header;